import React from 'react';

import { SourceAbbr } from '@dndbeyond/character-common-components/es';
import { BuilderChevronRightSvg } from '@dndbeyond/character-components/es';
import {
    RaceDefinitionContract,
    RaceUtils,
    RuleData,
    RuleDataUtils,
    SourceUtils,
} from '@dndbeyond/character-rules-engine/es';

import {
    FilterListingItemContent,
    FilterListingItemContentHeading,
} from '../../../Shared/components/common/FilterListing';

interface SourceProps {
    isHomebrew: boolean;
    race: RaceDefinitionContract;
    ruleData: RuleData;
}
const Source: React.FC<SourceProps> = ({ isHomebrew, race, ruleData }) => {
    if (isHomebrew) {
        return <SourceAbbr sourceName="Homebrew" />;
    }
    return (
        <React.Fragment>
            {SourceUtils.getSourceFullNames(RaceUtils.getSources(race), ruleData).map((source, idx) => {
                return (
                    <React.Fragment>
                        {idx > 0 ? ' /' : ''} <SourceAbbr sourceName={source} />
                    </React.Fragment>
                );
            })}
        </React.Fragment>
    );
};

interface Props {
    race: RaceDefinitionContract;
    ruleData: RuleData;
    defaultImageUrl: string;
}
export const RaceFilterListingItemContent: React.FC<Props> = ({ race, ruleData, defaultImageUrl }) => {
    const baseName = RaceUtils.getBaseName(race);
    const subRaceShortName = RaceUtils.getSubRaceShortName(race);
    const isHomebrew = RaceUtils.getIsHomebrew(race);
    const portraitAvatarUrl = RaceUtils.getPortraitAvatarUrl(race);

    return (
        <FilterListingItemContent clsNames={['filter-listing-item-content-race']}>
            <FilterListingItemContentHeading>
                <div className="race-filter-item-header">
                    <div className="race-filter-item-preview">
                        <img
                            className="race-filter-item-preview-img"
                            src={portraitAvatarUrl ?? defaultImageUrl}
                            alt=""
                        />
                    </div>
                    <div className="race-filter-item-info">
                        <div className="race-filter-item-parent">
                            {subRaceShortName && `${subRaceShortName} `}
                            {baseName}
                        </div>
                        {/* <div className="race-filter-item-source">
                            <Source ruleData={ruleData} isHomebrew={isHomebrew} race={race} />
                        </div> */}
                    </div>
                    <div className="race-filter-item-action">
                        <BuilderChevronRightSvg />
                    </div>
                </div>
            </FilterListingItemContentHeading>
        </FilterListingItemContent>
    );
};

export default RaceFilterListingItemContent;
